import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AudienceTypeEnum } from 'app/library/grow/enums/audience-type.enum';
import { AudienceService } from 'app/library/audience/services/audience.service';

@Component({
    selector: 'app-grow-new-automatic-audience-dialog',
    templateUrl: './grow-new-automatic-audience-dialog.component.html',
    styleUrls: ['./grow-new-automatic-audience-dialog.component.scss'],
})
export class GrowNewAutomaticAudienceDialogComponent implements OnInit {
    @Input()
    parentAudienceId: string;

    get name() {
        return this.formGroup.get('name');
    }

    private _formGroup: FormGroup;

    get formGroup(): FormGroup {
        return this._formGroup;
    }

    constructor(
        private _formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<GrowNewAutomaticAudienceDialogComponent>,
        public audienceService: AudienceService
    ) {}

    ngOnInit(): void {
        this._formGroup = this._formBuilder.group({
            name: ['', Validators.required],
        });
    }

    handleKeyUp(e: KeyboardEvent): void {
        if (e.key === 'Enter') {
            this.onAddNewAutomaticAudience();
        }
    }

    async onAddNewAutomaticAudience(): Promise<void> {
        const audience = {
            ...this.formGroup.value,
            parent: { id: this.parentAudienceId },
            type: AudienceTypeEnum.AUTOMATIC,
        };
        this.dialogRef.close(await this.audienceService.createAudience(audience));
    }
}
